module.exports = __webpack_public_path__ + "assets/img/3.b8a4f8da.jpg";